import { SUPPORTED_LOCALES_OBJ } from '@zep-us/i18n';
import { type GetStaticPropsContext, type NextPageWithLayout } from 'next';
import { getEmptyLayout } from '@/layout';
import { getDefaultStaticProps } from '@/utils/next';
import { createTranslationAtSSR } from '@/utils/ssr/createTranslationAtSSR';
import { NewBoardPageView } from './NewBoardPageView';
const NewBoardPage: NextPageWithLayout = () => {
  return <NewBoardPageView data-sentry-element="NewBoardPageView" data-sentry-component="NewBoardPage" data-sentry-source-file="index.page.tsx" />;
};
NewBoardPage.getLayout = function (page) {
  return getEmptyLayout(page);
};
export default NewBoardPage;

// /board/landing 랜딩과 같은 title/description 을 쓴다 — 별도 문구(seo.boardNew.*)를
// 시트에 만들어 뒀지만, 랜딩과 통일해 달라는 요청으로 재사용한다.
const getSeoTitle = (t: ReturnType<typeof createTranslationAtSSR>) => {
  return t({
    key: 'seo.board.title'
  });
};
const getSeoDescription = (t: ReturnType<typeof createTranslationAtSSR>) => {
  return t({
    key: 'seo.board.description'
  });
};
export const getStaticProps = async ({
  locale = SUPPORTED_LOCALES_OBJ.en
}: GetStaticPropsContext) => {
  const {
    props: defaultProps,
    revalidate
  } = await getDefaultStaticProps({
    locale,
    namespaces: ['common', 'board', 'boardTemplates']
  });
  const t = createTranslationAtSSR(defaultProps._nextI18Next, locale);
  return {
    props: {
      ...defaultProps,
      seoContent: {
        title: getSeoTitle(t),
        description: getSeoDescription(t)
      }
    },
    revalidate
  };
};